import React from 'react';
import { useDispatch } from 'react-redux';
import convertBitToBytes from '../../../../../../../utils/convertBitToBytes.utils';
import TorrentService from '../../../../../Torrent.service';
import './ResultLine.css';
import TorrentSearchService from '../../Results.service';
export default function ResultLine({result}) {
    const dispatch = useDispatch();
    
    const addTorrent = () => {
        TorrentService.addFromSearch(dispatch, result);
    };

    return <tr className='ResultLine'>
    <td><button onClick={() => !result.status && addTorrent()} className={`${TorrentSearchService.getAddColor(result)} sm block`}>{TorrentSearchService.getAddText(result)}</button></td>
    <td className='ResultLine-name'><a href={result.comment || result.link} target="_blank" rel="noopener noreferrer">{result.name}</a></td>
    <td>{convertBitToBytes(result.size)}</td>
    <td>{result.seeders}</td>
    <td>{result.leechers}</td>
    <td className='ResultLine-tracker'>{result.trackerName}</td>
</tr>
}